__turbopack_context__.v({
  "animate-popover-in": "animations-module__aq1Svq__animate-popover-in",
  "animate-popover-out": "animations-module__aq1Svq__animate-popover-out",
  "popover-in": "animations-module__aq1Svq__popover-in",
  "popover-out": "animations-module__aq1Svq__popover-out",
});
